import { createContext } from 'react';

export const VscCleanupContext = createContext();
export const VscCleanupDispatchContext = createContext();
